import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'justonweb-test-environment',
    templateUrl: './test-environment.component.html',
    styleUrls: ['./test-environment.component.scss'],
    standalone: false
})
export class TestEnvironmentComponent {

  static openDialog(dialog: MatDialog): MatDialogRef<TestEnvironmentComponent> {
    return dialog.open(TestEnvironmentComponent);
  }

}
